import { type BffUserInfoResponseDistributorModel } from '../generated/api-client/models/bff-user-info-response-distributor-model';

export enum DistributorRegionEnum {
  UK = 'UK',
  US = 'US',
  EU = 'EU',
}

export enum DistributorStatusEnum {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}

export const GetDistributorContext = [
  'quotes_filter',
  'policies_filter',
  'certificates_filter',
  'claims_filter',
  'quotes_creation',
  'certificates_creation',
  'claims_creation',
  'storage_locations_filter',
  'storage_locations_creation',
  'storage_declarations_creation',
] as const;

export type Distributor = BffUserInfoResponseDistributorModel & {
  // TODO HACK: types should be narrowed down in the API
  id: number;
  company_name: string;
  legal_name: string;
};
